import { M61UspModule } from '~/lib/data-contract';
import { Container } from '../container/container.component';
import styles from './m61-usp.module.css';
import { CMSLink, MediaImage, Typography } from '~/shared/components';
import clsx from 'clsx';

export type M61USPProps = M61UspModule;

const M61USP = ({ items, spacingTop, spacingBottom, ...rest }: M61USPProps) => {
    const uspCount = items?.length ?? 0;
    const maxPerLine = uspCount % 3 ? 4 : 3;
    const columnCount = Math.min(uspCount, maxPerLine);

    return (
        <Container
            hasGutter
            spacingTop={spacingTop || 'default'}
            spacingBottom={spacingBottom || 'default'}
            className={clsx(styles.root, styles[`columns-${columnCount}`])}
            {...rest}
        >
            {items?.map(({ headline, text, image, link }, index) => (
                <CMSLink href={link?.url} className={styles.item} key={index}>
                    {image?.src && (
                        <MediaImage
                            src={image.src}
                            alt={image.alt ?? ''}
                            className={styles.image}
                            height={60}
                            width={60}
                            mimeType="image/svg+xml"
                        />
                    )}
                    <div className={styles.content}>
                        {headline && (
                            <Typography as="b" className={styles.headline} children={headline} />
                        )}
                        {text && <Typography as="span" variant="bodySm" children={text} />}
                    </div>
                </CMSLink>
            ))}
        </Container>
    );
};

export default M61USP;
